export default __webpack_public_path__ + "static/media/hht2_ep17_speaking_02.e7b0182e.png";